import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { HOST_URL } from 'utils';

const $http = new APIManager();

const Api = {
  /**
   * [POST] SMS 전송
   * --
   */
  bizSendSMS: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_SEND_SMS, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] LMS 전송
   * --
   */
  bizSendLMS: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_SEND_LMS, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] MMS 전송
   * --
   */
  bizSendMMS: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_SEND_MMS, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 알림톡 전송
   * --
   */
  bizSendKakaoAt: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_SEND_KAKAO_AT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 이미지 알림톡 전송
   * --
   */
  bizSendKakaoAi: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_SEND_KAKAO_AI, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 파일 업로드
   * --
   */
  bizFileUpload: async (body) => {
    try {
      const res = await $http.multipart(APIConstant.BIZ_FILE_UPLOAD, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 등록
   * --
   */
  bizTemplateAdd: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_TEMPLATE_ADD, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 코드 유효성 검증
   * --
   */
  bizTemplateCodeCheck: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_TEMPLATE_CODE_CHECK, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 목록 조회
   * --
   */
  bizTemplateList: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_TEMPLATE_LIST, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 상세조회
   * --
   */
  bizTemplateDetail: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_TEMPLATE_DETAIL, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 수정
   * --
   */
  bizTemplateUpdate: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_TEMPLATE_UPDATE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 삭제
   * --
   */
  bizTemplateDelete: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_TEMPLATE_DELETE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 카테고리 전체 조회
   * --
   */
  bizTemplateCategoryAll: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_TEMPLATE_CATEGORY_ALL, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 카테고리 단일 조회
   * --
   */
  bizTemplateCategory: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_TEMPLATE_CATEGORY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 검수 요청
   * --
   */
  bizTemplateRequest: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_TEMPLATE_REQUEST, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 검수 요청 취소
   * --
   */
  bizTemplateCancelRequest: async (body) => {
    try {
      const res = await $http.post(
        APIConstant.BIZ_TEMPLATE_CANCEL_REQUEST,
        body
      );

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 사용 중지
   * --
   */
  bizTemplateStop: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_TEMPLATE_STOP, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 사용 중지 해제
   * --
   */
  bizTemplateReuse: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_TEMPLATE_REUSE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 승인 취소
   * --
   */
  bizTemplateCancelApproval: async (body) => {
    try {
      const res = await $http.post(
        APIConstant.BIZ_TEMPLATE_CANCEL_APPROVAL,
        body
      );

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 휴먼 해제
   * --
   */
  bizTemplateRelease: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_TEMPLATE_RELEASE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 전환
   * --
   */
  bizTemplateConvertAddCh: async (body) => {
    try {
      const res = await $http.post(
        APIConstant.BIZ_TEMPLATE_CONVERT_ADD_CH,
        body
      );

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] 템플릿 변환
   * --
   */
  bizTemplateReplace: async (body) => {
    try {
      const res = await $http.post(APIConstant.BIZ_TEMPLATE_REPLACE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
